export const POKEMON_IMAGE_TYPE = {
    OFFICIAL_ARTWORK: 'officialArtworkFront',
    DREAM_WORLD: 'dreamWorldFront',
    FRONT_DEFAULT: 'frontDefault'
} as const